module.exports = __webpack_public_path__ + "img/2-Laguna de Xalapango.a960923f.jpg";